import { createErrorWrapper } from '../utils';

export const AUTH_ERROR = 'AUTH.AUTH_ERROR';

export const authErr = createErrorWrapper(AUTH_ERROR, 'Не удалось авторизоваться');
